<template>
  <b-form-group
    class=""
    :description="'Which language would you like to use?'"
  >
    <template slot="label">
      Select language
    </template>
    <b-form-select
      v-model="language"
      :options="languages"
      @change="emitChange"
    />
  </b-form-group>
</template>
<script>
export default {
  name: 'SelectLanguage',
  props: {
    enabledFor: {
      type: String,
      default: 'language_enabled'
    },
    defaultlanguage: {
      type: Number,
      default: 38
    }
  },
  data () {
    return {
      language: 38,
      languages: []
    }
  },
  mounted () {
    this.language = this.defaultlanguage
    this.languages_get()
  },
  methods: {
    emitChange (value) {
      this.$emit('languagechange', value)
    },
    languages_get () {
      this.languages = []
      let filter = {}
      filter[this.enabledFor] = {
        operator: '=',
        value: '1'
      }
      const payload = {
        table_name: 'g_languages',
        filter: filter
      }
      this.$store.dispatch('records_readall', payload)
        .then((resp) => {
          for (let i = 0; i < resp.data.result.length; i++) {
            this.languages.push(
              {
                value: resp.data.result[i].id,
                text: resp.data.result[i].language_name
              }
            )
          }
        })
    }
  }
}
</script>
<style>
</style>
